import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import { api, go, cover } from './util';

/**
 * /events/new: create an event. A cover picture on the left; on the right the name, start and end, time zone,
 * location (in person, online or both), description and ticket options. Members' events wait for a moderator;
 * the server checks everything again (Events.php).
 */
export default class EventForm extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.places = null;
    this.timezones = {};
    this.errors = {};
    this.saving = false;
    this.uploading = false;
    this.placeQuery = '';
    let browserTz = 'Africa/Lagos';
    try {
      browserTz = Intl.DateTimeFormat().resolvedOptions().timeZone || browserTz;
    } catch (e) {}
    const d = new Date(Date.now() + 7 * 86400e3);
    const iso = d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
    this.f = {
      title: '',
      date: iso,
      start: '18:00',
      end_date: iso,
      end: '21:00',
      format: 'in_person',
      place: '',
      placeName: '',
      venue: '',
      address: '',
      online_url: '',
      ticket_url: '',
      price: '',
      description: '',
      timezone: browserTz,
      image_url: ''
    };
    app.request({
      method: 'GET',
      url: api() + '?limit=1&form=1',
      errorHandler: () => {}
    }).then(r => {
      this.places = r.places || [];
      this.timezones = r.timezones || {};
      if (!this.timezones[this.f.timezone]) this.timezones[this.f.timezone] = this.f.timezone.replace(/_/g, ' ');
    }).catch(() => this.places = []).then(() => m.redraw());
  }
  set(key) {
    return e => {
      this.f[key] = e.target.value;
      delete this.errors[key];
      if (key === 'date' && (!this.f.end_date || this.f.end_date < this.f.date)) this.f.end_date = this.f.date;
    };
  }
  pick(p) {
    this.f.place = p.slug;
    this.f.placeName = p.name;
    this.f.timezone = p.timezone;
    if (!this.timezones[p.timezone]) this.timezones[p.timezone] = p.timezone.replace(/_/g, ' ');
    this.placeQuery = '';
    delete this.errors.place;
  }
  upload(e) {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    const body = new FormData();
    body.append('image', file);
    this.uploading = true;
    delete this.errors.image_url;
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/voucha-community/events-image',
      body,
      serialize: raw => raw,
      errorHandler: () => {}
    }).then(r => {
      if (r && r.errors) this.errors.image_url = r.errors.image;else this.f.image_url = r.url;
    }).catch(err => this.errors.image_url = err && err.response && err.response.errors && err.response.errors.image || 'The picture could not be uploaded.').then(() => {
      this.uploading = false;
      e.target.value = '';
      m.redraw();
    });
  }
  submit(e) {
    e.preventDefault();
    this.saving = true;
    this.errors = {};
    // the end is optional: send it only if it's set
    const body = Object.assign({}, this.f);
    if (!body.end) body.end_date = '';
    app.request({
      method: 'POST',
      url: api(),
      body,
      errorHandler: () => {}
    }).then(r => {
      if (r && r.errors) {
        this.saving = false;
        this.errors = r.errors;
        m.redraw();
        setTimeout(() => {
          const first = document.querySelector('.VEvtF .has-error, .VEvtF-alert');
          if (first) first.scrollIntoView({
            block: 'center',
            behavior: 'smooth'
          });
        }, 30);
        return;
      }
      const live = r.event && r.event.status === 'approved';
      app.alerts.show({
        type: 'success'
      }, live ? 'Your event is live.' : 'Thanks. Your event will go live once a moderator has checked it.');
      m.route.set('/events/' + r.id);
    }).catch(err => {
      this.saving = false;
      this.errors = err && err.response && err.response.errors || {
        form: 'Could not create the event. Please try again.'
      };
      m.redraw();
      setTimeout(() => {
        const first = document.querySelector('.VEvtF .has-error, .VEvtF-alert');
        if (first) first.scrollIntoView({
          block: 'center',
          behavior: 'smooth'
        });
      }, 30);
    });
  }
  err(...keys) {
    const msgs = keys.map(k => this.errors[k]).filter(Boolean);
    return msgs.length ? msgs.map(t => m("p", {
      className: "VEvtF-error"
    }, t)) : null;
  }
  has(...keys) {
    return keys.some(k => this.errors[k]) ? ' has-error' : '';
  }
  view() {
    if (!app.session.user) {
      return m("div", {
        className: "VEvt VEvt-empty"
      }, m("p", null, "Log in or sign up to create an event."), m("a", {
        href: "/events",
        onclick: go('/events')
      }, "\u2190 Events"));
    }
    if (!this.places) return m(LoadingIndicator, null);
    const f = this.f;
    const q = this.placeQuery.trim().toLowerCase();
    const matches = q ? this.places.filter(p => p.name.toLowerCase().includes(q)).slice(0, 8) : [];
    const inPerson = f.format !== 'online';
    const online = f.format !== 'in_person';
    const today = new Date().toISOString().slice(0, 10);
    const errorCount = Object.keys(this.errors).length;
    const preview = {
      id: 7,
      image: f.image_url,
      startsAt: (f.date || today) + 'T12:00:00Z',
      timezone: 'UTC'
    };
    return m("form", {
      className: "VEvt VEvtF",
      onsubmit: e => this.submit(e)
    }, errorCount ? m("p", {
      className: "VEvtF-alert"
    }, this.errors.form || 'Please fix the highlighted parts below.') : null, m("div", {
      className: "VEvtF-layout"
    }, m("div", {
      className: "VEvtF-side"
    }, m("label", {
      className: 'VEvtF-coverBox' + this.has('image_url')
    }, cover(preview, 'VEvtF-cover'), m("span", {
      className: "VEvtF-coverButton"
    }, m("i", {
      className: this.uploading ? 'fas fa-spinner fa-spin' : 'fas fa-image',
      "aria-hidden": "true"
    })), m("input", {
      type: "file",
      accept: "image/jpeg,image/png,image/webp",
      onchange: e => this.upload(e)
    })), m("p", {
      className: "VEvtF-hint"
    }, f.image_url ? 'Tap the picture to change it.' : 'Add a cover picture (square works best). Without one, a pattern is used.'), this.err('image_url')), m("div", {
      className: "VEvtF-main"
    }, m("div", {
      className: 'VEvtF-title' + this.has('title')
    }, m("input", {
      maxlength: "150",
      value: f.title,
      oninput: this.set('title'),
      placeholder: "Event name",
      "aria-label": "Event name"
    }), this.err('title')), m("div", {
      className: 'VEvtF-when' + this.has('date', 'end', 'timezone')
    }, m("div", {
      className: "VEvtF-times"
    }, m("div", {
      className: "VEvtF-timeRow"
    }, m("span", {
      className: "VEvtF-dot"
    }), m("span", {
      className: "VEvtF-label"
    }, "Start"), m("input", {
      type: "date",
      min: today,
      value: f.date,
      oninput: this.set('date'),
      "aria-label": "Start date"
    }), m("input", {
      type: "time",
      value: f.start,
      oninput: this.set('start'),
      "aria-label": "Start time"
    })), m("div", {
      className: "VEvtF-timeRow"
    }, m("span", {
      className: "VEvtF-dot is-end"
    }), m("span", {
      className: "VEvtF-label"
    }, "End"), m("input", {
      type: "date",
      min: f.date || today,
      value: f.end_date,
      oninput: this.set('end_date'),
      "aria-label": "End date"
    }), m("input", {
      type: "time",
      value: f.end,
      oninput: this.set('end'),
      "aria-label": "End time"
    }))), m("label", {
      className: "VEvtF-tz"
    }, m("i", {
      className: "fas fa-globe",
      "aria-hidden": "true"
    }), m("select", {
      value: f.timezone,
      onchange: this.set('timezone'),
      "aria-label": "Time zone"
    }, Object.entries(this.timezones).map(([k, label]) => m("option", {
      value: k
    }, label))))), this.err('date', 'end', 'timezone'), m("div", {
      className: 'VEvtF-block' + this.has('format', 'place', 'venue', 'online_url')
    }, m("div", {
      className: "VEvtF-blockHead"
    }, m("i", {
      className: "fas fa-location-dot",
      "aria-hidden": "true"
    }), m("span", null, m("strong", null, "Event location"), m("small", null, "In person, online or both"))), m("div", {
      className: "VEvtF-seg",
      role: "radiogroup"
    }, [['in_person', 'In person'], ['online', 'Online'], ['hybrid', 'Both']].map(([k, label]) => m("button", {
      type: "button",
      role: "radio",
      "aria-checked": f.format === k ? 'true' : 'false',
      className: f.format === k ? 'is-on' : '',
      onclick: () => (f.format = k, delete this.errors.format)
    }, label))), m("div", {
      className: "VEvtF-place"
    }, m("input", {
      placeholder: f.placeName ? f.placeName + ' (type to change)' : inPerson ? 'City or state: Lagos, Kano, Toronto…' : 'City or state (optional)',
      value: this.placeQuery,
      oninput: e => this.placeQuery = e.target.value,
      "aria-label": "City or state"
    }), f.placeName ? m("span", {
      className: "VEvtF-chosen"
    }, f.placeName, m("button", {
      type: "button",
      "aria-label": "Clear",
      onclick: () => (f.place = '', f.placeName = '')
    }, "\xD7")) : null, matches.length ? m("ul", {
      className: "VouchaJoin-results"
    }, matches.map(p => m("li", null, m("button", {
      type: "button",
      onclick: () => this.pick(p)
    }, m("strong", null, p.name), " ", m("small", null, p.sub))))) : null), inPerson ? m("input", {
      maxlength: "150",
      value: f.venue,
      oninput: this.set('venue'),
      placeholder: "Venue (e.g. Landmark Centre, or Shared after sign-up)",
      "aria-label": "Venue"
    }) : null, inPerson ? m("input", {
      maxlength: "200",
      value: f.address,
      oninput: this.set('address'),
      placeholder: "Address (optional)",
      "aria-label": "Address"
    }) : null, online ? m("input", {
      type: "url",
      maxlength: "300",
      value: f.online_url,
      oninput: this.set('online_url'),
      placeholder: "Online link: Zoom, Meet, YouTube\u2026 (https://)",
      "aria-label": "Online link"
    }) : null), this.err('format', 'place', 'venue', 'online_url'), m("div", {
      className: 'VEvtF-block' + this.has('description')
    }, m("div", {
      className: "VEvtF-blockHead"
    }, m("i", {
      className: "far fa-file-lines",
      "aria-hidden": "true"
    }), m("span", null, m("strong", null, "Description"))), m("textarea", {
      rows: "6",
      maxlength: "4000",
      value: f.description,
      oninput: this.set('description'),
      placeholder: "What it is, who it's for, the programme, what to bring.",
      "aria-label": "Description"
    })), this.err('description'), m("h4", {
      className: "VEvtF-optionsTitle"
    }, "Event options"), m("div", {
      className: 'VEvtF-options' + this.has('price', 'ticket_url')
    }, m("label", {
      className: "VEvtF-option"
    }, m("i", {
      className: "fas fa-ticket",
      "aria-hidden": "true"
    }), m("span", null, "Ticket price"), m("input", {
      maxlength: "60",
      value: f.price,
      oninput: this.set('price'),
      placeholder: "Free",
      "aria-label": "Ticket price"
    })), m("label", {
      className: "VEvtF-option"
    }, m("i", {
      className: "fas fa-link",
      "aria-hidden": "true"
    }), m("span", null, "Tickets or registration link"), m("input", {
      type: "url",
      maxlength: "300",
      value: f.ticket_url,
      oninput: this.set('ticket_url'),
      placeholder: "Optional (https://)",
      "aria-label": "Tickets or registration link"
    })), m("div", {
      className: "VEvtF-option is-info"
    }, m("i", {
      className: "fas fa-user-check",
      "aria-hidden": "true"
    }), m("span", null, "Checked by a moderator before it goes live"))), this.err('price', 'ticket_url'), m(Button, {
      className: "Button Button--primary VEvtF-submit",
      type: "submit",
      loading: this.saving,
      disabled: this.uploading
    }, "Create event"))));
  }
}
flarum.reg.add('voucha-community', 'forum/events/EventForm', EventForm);